import { useApiQueries } from '../../app/ApiClientContext';

export function useMe() {
  const $api = useApiQueries();
  return $api.useQuery('get', '/api/v2/auth/me');
}
